require('./bootstrap');
import MobileMenu from "./components/MobileMenu";

const $ = window.jQuery || window.$;

const DEFAULT_LOADING_TEXT = 'Please wait...'

function getSubmitButton(form) {
    if (!form) {
        return null
    }

    return form.__activeSubmitButton || form.querySelector('button[type="submit"], input[type="submit"]')
}

function disableSubmitButton(form, button = null) {
    const submitButton = button || getSubmitButton(form)

    if (!submitButton || submitButton.disabled) {
        return submitButton
    }

    const isInput = submitButton.tagName === 'INPUT'
    const currentText = isInput ? submitButton.value : submitButton.textContent

    submitButton.dataset.originalText = currentText
    submitButton.disabled = true
    submitButton.classList.add('opacity-70', 'cursor-not-allowed')

    const loadingText = submitButton.dataset.loadingText || DEFAULT_LOADING_TEXT

    if (isInput) {
        submitButton.value = loadingText
    } else {
        submitButton.textContent = loadingText
    }

    return submitButton
}

function enableSubmitButton(form, button = null) {
    const submitButton = button || getSubmitButton(form)

    if (!submitButton) {
        return
    }

    const isInput = submitButton.tagName === 'INPUT'
    const originalText = submitButton.dataset.originalText

    submitButton.disabled = false
    submitButton.classList.remove('opacity-70', 'cursor-not-allowed')

    if (originalText) {
        if (isInput) {
            submitButton.value = originalText
        } else {
            submitButton.textContent = originalText
        }
    }
}

window.FormSubmitState = {
    disable: disableSubmitButton,
    enable: enableSubmitButton,
    getButton: getSubmitButton,
}

document.addEventListener('click', function (event) {
    const submitButton = event.target.closest('button[type="submit"], input[type="submit"]')

    if (!submitButton || !submitButton.form) {
        return
    }

    submitButton.form.__activeSubmitButton = submitButton
})

document.addEventListener('submit', function (event) {
    disableSubmitButton(event.target)
}, true)

const menu = new MobileMenu(
    {
        openTrigger: '#mobile-menu-open',
        closeTrigger: '#mobile-menu-close',
        menu: '#mobile-menu',
        contactLink: '.contact-link'
    },
    ['offscreen']
)

menu.init()

var kittingButton = document.getElementById('kittingButton')

if (kittingButton) {
    kittingButton.addEventListener('click', function () {
        if (kittingButton.querySelector('img').classList.contains('rotate-180')) {
            kittingButton.querySelector('img').classList.remove('rotate-180')
            kittingButton.querySelector('span').textContent = 'Read Less'
            document.getElementById('kitting').classList.remove('lg:mb-40', 'mb-20')
            document.getElementById('kittingContent').classList.remove('hidden')
        } else {
            kittingButton.querySelector('img').classList.add('rotate-180')
            kittingButton.querySelector('span').textContent = 'Read more'
            document.getElementById('kitting').classList.add('lg:mb-40', 'mb-20')
            document.getElementById('kittingContent').classList.add('hidden')
        }
    })
}

if (typeof $ === 'function') {
    $('.js-article-button').on('click', function () {
        if ($(this).children('img').hasClass('rotate-180')) {
            $(this).children('img').removeClass('rotate-180')
            $(this).children('span').text('Read Less')
            $(this).closest('.js-article').children('.js-article-content').removeClass('hidden')
        } else {
            $(this).children('img').addClass('rotate-180')
            $(this).children('span').text('Read more')
            $(this).closest('.js-article').children('.js-article-content').addClass('hidden')
        }
    })
}
